<template>
  <perfect-scrollbar id="menuManager" class="content" v-on:click="sectionClicked"
    :class="{collapsed: collapsed, started: started}" v-on:scroll="onScrolled">
    <div class="currentBilling">
      <div>
        <h4 class="cbTtl">Menu Manager</h4>
        <p class="cbP">Menu manager is virtual router to your Content Directory.<br />
        Here you can add, edit, remove menu in here or sort with drag n drop.</p>
      </div>
    </div>
    <div class="menuCnt loading" v-if="loading"></div>
    <div class="menuSc" v-else>
      <div class="menuCnt menuCntMain"
        :class="{menuFixed: menu.length < 5, menuFixedSm: menu.length < 4}"
        :style="{width: `${(370 * menu.length) + 180}px`}">
        <draggable v-model="menu" class="menuDragableMain"
          group="menu" v-on:change="doSaveMenu('draft')" v-if="menu.length > 0">
          <div class="menuItem" v-for="(m, i) in menu" :key="`mn${i}`"
            :class="{collapsed: m.collapsed, noSub: !m.submenus || m.submenus.length < 1}"
            :style="{width: `${100 / menu.length}%`}">
            <div class="menu" v-on:click="m.collapsed = !m.collapsed"
              :class="{unpublished: m.status === 'unpublished'}">
              <div class="menuName">
                <span :contenteditable="menuEdit" v-on:click.stop="rename(m, i)"
                  :ref="`menu-name-${i}`" v-on:focus="nameFocused"
                  v-on:keydown="nameKeydown"
                  v-on:blur="saveMenu($event, m, i)">
                  {{m.name[lang]}}
                </span>
              </div>
              <div class="menuInfo">
                {{m.type}}
                <template v-if="m.page"> - {{m.page.name[lang]}}</template>
                <template v-if="m.pages && m.pages.length > 0">
                  - {{m.pages[0].name[lang]}}
                  <template v-if="m.pages.length > 1">
                    +{{m.pages.length - 1}} more
                  </template>
                </template>
                <template v-if="m.content"> - {{m.content.title[lang]}}</template>
                <template v-if="m.directory"> - {{m.directory.name[lang]}}</template>
                <template v-if="m.link"> - {{m.link}}</template>
              </div>
              <div class="menuAction">
                <div class="actionItem clicked">
                  <template v-if="m.viewCount >= 1000000000">
                    {{Math.floor(m.viewCount/1000000000).toLocaleString('id')}}b
                  </template>
                  <template v-else-if="m.viewCount >= 1000000">
                    {{Math.floor(m.viewCount/1000000).toLocaleString('id')}}m
                  </template>
                  <template v-if="m.viewCount >= 1000">
                    {{Math.floor(m.viewCount/1000).toLocaleString('id')}}k
                  </template>
                  <template v-else-if="m.viewCount">
                    {{m.viewCount.toLocaleString('id')}}
                  </template>
                  <div class="info" v-if="m.viewCount">
                    Opened <b>{{m.viewCount.toLocaleString('id')}}</b>x
                  </div>
                </div>
                <div class="actionItem unpublished"
                  v-if="m.status === 'unpublished'" v-on:click.stop="publish(m, i)">
                  <div class="info">Publish menu</div>
                </div>
                <div class="actionItem published" v-else v-on:click.stop="unpublish(m, i)">
                  <div class="info">Unpublish menu</div>
                </div>
                <div class="actionItem more" v-on:click.stop="menuMore = i"
                  :class="{open: menuMore === i}">
                  <div class="menuOverlay" v-if="menuMore === i"
                    v-on:click.stop="menuMore = null"></div>
                  <div class="actionMenu" v-if="menuMore === i"
                    v-on:click.stop="doNothing">
                    <li v-on:click="editMenu(m, i)">
                      <div class="icon edit"></div> Edit</li>
                    <div class="divider"></div>
                    <li v-on:click="openMenu(m, i)">
                      <div class="icon link"></div> Open Menu</li>
                    <li v-on:click="rename(m, i)">
                      <div class="icon rename"></div> Rename</li>
                    <li v-on:click="unpublish(m, i)" v-if="m.status === 'published'">
                      <div class="icon unpublish"></div> Unpublish</li>
                    <li v-on:click="publish(m, i)" v-else>
                      <div class="icon publish"></div> Publish</li>
                    <div class="divider"></div>
                    <li class="red" v-on:click="deleteItem(m, i)">
                      <div class="icon delete"></div> Delete Item</li>
                  </div>
                </div>
              </div>
            </div>
            <draggable v-if="m.submenus" group="submenu"
              v-model="m.submenus" v-on:change="doSaveMenu('draft')">
              <Submenu :submenu="submenu"
                v-for="(submenu, i2) in m.submenus" :key="`sm${i2}`"
                v-on:saveMenu="doSaveMenu('draft')" v-on:openMenu="openMenu"
                v-on:delete="deleteSubmenu(m, i2)"></Submenu>
            </draggable>
            <div class="addMenuCnt">
              <div class="menu addMenu _btnAdd" v-on:click="addSubmenu(m)">Submenu</div>
            </div>
          </div>
        </draggable>
        <div class="menuItem last" :class="{noMenu: menu.length < 1}">
          <button class="btnAdd" v-on:click="addMenu">Add Menu</button>
        </div>
      </div>
    </div>
    <div class="mmFooter">
      <div class="draftStatus" v-if="hasDraft">Draft</div>
      <div class="actionCnt">
        <div class="actionItem history" v-on:click.stop="openHistory"
          :class="{open: historyOpen}">
          <span class="info">Revision history</span>
          <div class="actionMenu" v-if="historyOpen">
            <h4>Revision History</h4>
            <div class="historyCnt loading" v-if="loadingHistory"></div>
            <div class="historyCnt noData" v-else-if="history.length < 1">
              <div class="noDataIn">
                <img src="../assets/no-history.png">
                There are currently no history
              </div>
            </div>
            <div class="historyCnt" v-else>
              <div class="historyItem" v-for="item in history" :key="`h${item.id}`"
                v-on:click="selectHistory(item)">
                <h5>{{item.dateCreated | moment('from', 'now')}}</h5>
                <p v-if="item.author">edited by <b>{{item.author.name}}</b></p>
                <div class="historyStatus" :class="item.status">
                  {{item.status}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="actionItem draft" :class="{loading: savingDraft, open: draftOpen}"
          v-on:click.stop="draftOpen = !draftOpen; historyOpen = false">
          <span class="info" v-if="savingDraft">Saving to draft...</span>
          <span class="info" v-else>Saved as draft</span>
          <div class="actionMenu" v-if="draftOpen" v-on:click.stop="doNothing">
            <li v-on:click="saveDraft">
              <div class="icon save"></div> Save as draft
            </li>
            <div class="divider"></div>
            <li class="red" v-on:click.stop="deleteDraft">
              <div class="icon delete"></div> Delete draft
            </li>
          </div>
        </div>
        <button class="btn btnPrimary" v-on:click="publishMenu">Publish</button>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <AddMenu ref="addMenu"/>
    <LoadingDialog ref="loadingDialog"/>
  </perfect-scrollbar>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import draggable from 'vuedraggable';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import Submenu from '@/components/Submenu.vue';
import AddMenu from '@/components/AddMenu.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';

export default {
  name: 'home',
  components: {
    draggable,
    Confirmation,
    Snackbar,
    Submenu,
    AddMenu,
    LoadingDialog,
  },
  data() {
    return {
      loading: false,
      menuMore: null,
      menuEdit: null,
      menu: [],
      siteUrl: '',
      hasDraft: false,

      /**
       * Action
       *
       */
      historyOpen: false,
      history: [],
      loadingHistory: true,
      savingDraft: false,
      collapsed: false,
      started: false,
      draftOpen: false,
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    ...mapActions(['chTitle', 'chCGB', 'chDirId']),
    doNothing() {},
    sectionClicked() {
      this.historyOpen = false;
      this.draftOpen = false;
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
      const collapsedStr = this.collapsed ? 'y' : 'n';
      localStorage.setItem(`${this.$config.appId}_mm_collapsed`, collapsedStr);
    },
    onScrolled(e) {
      if (e.target.scrollTop >= 100) {
        this.chTitle('Menu Manager');
      } else {
        this.chTitle('');
      }
    },
    saveMenu(e, m, i) {
      setTimeout(() => {
        this.menuEdit = null;
        m.name[this.lang] = e.target.innerText; // eslint-disable-line
        this.doSaveMenu('draft');
      });
    },
    publishMenu() {
      this.doSaveMenu('published');
    },
    doSaveMenu(status = 'draft') {
      if (status === 'draft') this.hasDraft = true;
      else this.hasDraft = false;
      this.savingDraft = true;
      const menuData = [];
      // eslint-disable-next-line
      for (const item of this.menu) {
        const menu = this.genMenuItem(item);
        if (item.submenus && item.submenus.length > 0) {
          // eslint-disable-next-line
          for (const s1 of item.submenus) {
            const s1x = { title: s1.title, status: s1.status, menus: [] };
            // eslint-disable-next-line
            for (const s1m of s1.menus) {
              const s1mx = this.genMenuItem(s1m);
              if (s1m.submenus && s1m.submenus.length > 0) {
                // eslint-disable-next-line
                for (const s2 of s1m.submenus) {
                  const s2x = { title: s2.title, status: s2.status, menus: [] };
                  // eslint-disable-next-line
                  for (const s2m of s2.menus) {
                    const s2mx = this.genMenuItem(s2m);
                    if (s2m.submenus && s2m.submenus.length > 0) {
                      // eslint-disable-next-line
                      for (const s3 of s2m.submenus) {
                        const s3x = { title: s3.title, status: s3.status, menus: [] };
                        // eslint-disable-next-line
                        for (const s3m of s3.menus) {
                          const s3mx = this.genMenuItem(s3m);
                          if (s3m.submenus && s3m.submenus.length > 0) {
                            // eslint-disable-next-line
                            for (const s4 of s3m.submenus) {
                              const s4x = { title: s4.title, status: s4.status, menus: [] };
                              // eslint-disable-next-line
                              for (const s4m of s4.menus) {
                                const s4mx = this.genMenuItem(s4m);

                                if (s4m.submenus && s4m.submenus.length > 0) {
                                  // eslint-disable-next-line
                                  for (const s5 of s4m.submenus) {
                                    const s5x = { title: s5.title, status: s5.status, menus: [] };
                                    // eslint-disable-next-line
                                    for (const s5m of s5.menus) {
                                      const s5mx = this.genMenuItem(s5m);
                                      s5x.menus.push(s5mx);
                                    }
                                    s4mx.submenus.push(s5x);
                                  }
                                }
                                s4x.menus.push(s4mx);
                              }
                              s3mx.submenus.push(s4x);
                            }
                          }
                          s3x.menus.push(s3mx);
                        }
                        s2mx.submenus.push(s3x);
                      }
                    }
                    s2x.menus.push(s2mx);
                  }
                  s1mx.submenus.push(s2x);
                }
              }
              s1x.menus.push(s1mx);
            }
            menu.submenus.push(s1x);
          }
        }
        menuData.push(menu);
      }
      this.$http.post(this.$config.uri('config/menu'), {
        status,
        menu: menuData,
      }).then((r) => {
        this.savingDraft = false;
        this.$refs.snackbar.open({ content: 'Changes has been saved' });
      });
    },
    genMenuItem(item) {
      const menu = {
        indexId: item.indexId,
        code: item.code,
        uri: item.uri,
        name: item.name,
        descriptions: item.descriptions,
        type: item.type,
        status: item.status,
        breadcrumb: item.breadcrumb,
        data: null,
        submenus: [],
      };
      if (item.type === 'Page') {
        if (item.page) menu.data = { pageId: item.page.id };
      } else if (item.type === 'Pages') {
        if (item.pages && item.pages.length > 0) {
          menu.data = [];
          // eslint-disable-next-line
          for (const page of item.pages) {
            menu.data.push({ pageId: page.id });
          }
        }
      } else if (item.type === 'Content') {
        if (item.content) menu.data = { contentId: item.content.id };
      } else if (item.type === 'Directory') {
        if (item.directory) menu.data = { directoryId: item.directory.id };
      } else if (item.type === 'External Link') {
        if (item.link) menu.data = { link: item.link };
      }
      return menu;
    },

    /**
     * Rename
     *
     */
    nameFocused(e) {
      setTimeout(() => {
        let sel;
        let range;
        if (window.getSelection && document.createRange) {
          range = document.createRange();
          range.selectNodeContents(e.target);
          sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        } else if (document.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(e.target);
          range.select();
        }
      });
    },
    nameKeydown(e) {
      if (e.code === 'Enter') {
        e.preventDefault();
        e.target.blur();
      }
    },

    /**
     * Draft
     *
     */
    saveDraft() {
      this.draftOpen = false;
      this.doSaveMenu('draft');
    },
    deleteDraft(item) {
      this.draftOpen = false;
      this.$refs.confirmDialog.open({
        title: 'Delete Draft',
        desc: 'Are you sure you want to delete draft for the menu? All changes will be lost',
      }, (b) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        this.$http.get(this.$config.uri('config/menu/draft/delete')).then((r) => {
          this.$refs.loadingDialog.close();
          this.hasDraft = false;
          this.getData();
        });
      });
    },

    /**
     * History
     *
     */
    openHistory() {
      this.draftOpen = false;
      this.historyOpen = !this.historyOpen;
      if (!this.historyOpen) return;
      this.loadingHistory = true;
      this.$http.get(this.$config.uri('config/menu/history')).then((r) => {
        this.loadingHistory = false;
        this.history = r.data.status === 200 ? r.data.data : [];
      });
    },
    selectHistory(item) {
      this.$refs.confirmDialog.open({
        title: 'Revert Changes',
        desc: 'Are you sure you want to revert state to this selected history item? Current changes will be lost',
        action: 'Revert Changes',
      }, (b) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        this.$http.get(this.$config.uri(`config/menu/history/${item.id}/revert`)).then((r) => {
          this.$refs.loadingDialog.close();
          this.getData();
        });
      });
    },

    /**
     * Actions
     *
     */
    openMenu(m, i) {
      this.menuMore = null;
      if (!m.uri) {
        this.$refs.confirmDialog.open({
          title: 'Menu Still On Draft',
          desc: 'Please publish changes to open menu page',
          error: true,
        });
        return;
      }
      if (m.type === 'Unclickable') {
        this.$refs.confirmDialog.open({
          title: 'Unclickable Menu',
          desc: 'There is no page to visit for menu with Unclickable type',
          error: true,
        });
        return;
      }
      const langCode = this.lang === 'id' ? 'id-id' : 'en-us';
      window.open(`${this.siteUrl}${langCode}/${m.uri}`, '_blank').focus();
    },
    addSubmenu(m) {
      this.$refs.confirmDialog.open({
        title: 'Add Submenu',
        desc: 'Please input Submenu name',
        action: 'Save',
        inputs: [
          {
            type: 'text',
            label: 'Submenu name',
            value: { en: '', id: '' },
          },
        ],
        multiLang: true,
      }, (b, c, d, v) => {
        if (!b) return;
        m.collapsed = false; // eslint-disable-line
        if (!m.submenus) m.submenus = []; // eslint-disable-line
        m.submenus.push({
          title: v[0].value,
          status: 'published',
          menus: [],
        });
        this.doSaveMenu('draft');
      });
    },
    addMenu() {
      this.$refs.addMenu.open(null, (b, m) => {
        if (!b) return;
        this.menu.push(m);
        this.doSaveMenu('draft');
      });
    },
    editMenu(item, i) {
      this.menuMore = null;
      this.$refs.addMenu.open(item, (b, m) => {
        if (!b) return;
        item.name = m.name; // eslint-disable-line
        item.descriptions = m.descriptions; // eslint-disable-line
        item.type = m.type; // eslint-disable-line
        item.page = m.page; // eslint-disable-line
        item.pages = m.pages; // eslint-disable-line
        item.content = m.content; // eslint-disable-line
        item.directory = m.directory; // eslint-disable-line
        item.link = m.link; // eslint-disable-line
        item.breadcrumb = m.breadcrumb; // eslint-disable-line
        this.doSaveMenu('draft');
      });
    },
    unpublish(m, i) {
      this.menuMore = null;
      const name = m.name[this.lang] || 'Menu Item';
      this.$refs.confirmDialog.open({
        title: `Unpublish ${name}`,
        desc: 'Unpublished item will not displayed in front-end',
        action: 'Unpublish',
      }, (b) => {
        if (!b) return;
        m.status = 'unpublished'; // eslint-disable-line
        this.doSaveMenu('draft');
      });
    },
    publish(m, i) {
      this.menuMore = null;
      const name = m.name[this.lang] || 'Menu Item';
      this.$refs.confirmDialog.open({
        title: `Publish ${name}`,
        desc: 'Published item will be displayed in the front-end',
        action: 'Publish',
      }, (b) => {
        if (!b) return;
        m.status = 'published'; // eslint-disable-line
        this.doSaveMenu('draft');
      });
    },
    deleteItem(m, i) {
      this.menuMore = null;
      const name = m.name[this.lang] || 'Menu Item';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: 'Are you sure you want to delete this menu item?',
      }, (b) => {
        if (!b) return;
        this.menu.splice(i, 1);
        this.doSaveMenu('draft');
      });
    },
    rename(m, i) {
      this.menuMore = null;
      this.menuEdit = i;
      setTimeout(() => {
        this.$refs[`menu-name-${i}`][0].focus();
      });
    },
    deleteSubmenu(m, i) {
      const name = m.submenus[i].title[this.lang] || 'Submenu';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: 'Are you sure you want to delete this menu item?',
      }, (b) => {
        if (!b) return;
        m.submenus.splice(i, 1);
        this.doSaveMenu('draft');
      });
    },

    /**
     * Get data
     *
     */
    getData() {
      this.loading = true;
      this.$http.get(this.$config.uri('config/menu')).then((r) => {
        this.loading = false;
        this.menu = (r.data.status === 200) ? r.data.data : [];
        this.hasDraft = this.menu.isDraft === true;
      });
    },
  },
  mounted() {
    if (this.$session.get('role') === 'editor') {
      this.$router.push('/content/amagram');
      return;
    }
    this.chTitle('Menu Manager');
    this.chCGB(false);
    this.chDirId(0);
    // this.collapsed = localStorage.getItem(`${this.$config.appId}_mm_collapsed`) === 'y';
    setTimeout(() => {
      this.started = true;
    }, 300);

    this.$http.get(this.$config.uri('config/item/siteUrl')).then((r) => {
      this.siteUrl = r.data.status === 200 ? r.data.data : 'https://cmsriver.com';
    });

    this.getData();
  },
};
</script>


<style lang="scss">
#menuManager{
  .menuCnt{
    text-align: left;
    .menuItem{
      &.sortable-ghost{
        .menu{
          background-color: #eee !important;
          *{
            opacity: 0;
          }
        }
      }
      &.sortable-chosen{
        .menu{
          background-color: #eee !important;
        }
      }
      &.sortable-drag{
        // background-color: #fff !important;
      }
      &.collapsed{
        .submenu{
          display: none;
        }
        .menu{
          &:before{
            transform: rotate(-90deg);
          }
        }
      }
      &.noSub{
        .menu{
          &:before{
            display: none;
          }
        }
      }
      .addMenuCnt{
        padding-left: 10px;
        &.addSubmenu2{
          padding-left: 40px;
        }
        &.addMenuItem{
          padding-left: 20px;
        }
      }
      .menu{
        font-weight: 600;
        padding: 8px 30px;
        padding-right: 50px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        font-size: 16px;
        background-color: #fff;
        text-align: left;
        transition: all .3s ease;
        padding-right: 110px;
        .menuName{
          span{
            padding-right: 24px;
            outline: 0;
            position: relative;
            white-space: nowrap;
            line-height: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            max-width: calc(100% - 24px);
            &:before{
              content: "";
              position: absolute;
              top: 0; right: 0; bottom: 0; width: 16px;
              background-image: url(../assets/rename.png);
              background-size: 16px auto;
              background-position: center;
              background-repeat: no-repeat;
              opacity: 0;
              transition: opacity .2s ease;
            }
            &:hover{
              &:before{
                opacity: .56;
              }
            }
          }
        }
        .menuInfo{
          margin-top: -2px;
          color: #767676;
          font-size: 14px;
          font-weight: 400;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        &.unpublished{
          .menuName{
            text-decoration: line-through;
          }
        }
        &.addMenu{
          border: none;
          display: block;
          color: #999;
          background-color: #fff !important;
          width: 100%;
          font-weight: 400;

          color: #0e5dd2;
          font-size: 15px;
          padding-left: 38px !important;
          padding-right: 10px;
          border-radius: 40px 0 0 40px !important;
          // margin-left: 20px;
          &:before{
            background-image: url(../assets/plus-black.png);
            background-size: 12px auto;
            opacity: .65;
            display: block !important;
            transform: none !important;

            background-image: url(../assets/plus-blue.png);
            background-size: 12px auto;
            opacity: 1;
            width: 12px;
            left: 19px !important;
          }
          &:hover{
            // color: #555;
            background-color: #f5f5fe !important;
            &:before{
              opacity: 1;
            }
          }
        }
        &:before{
          content: "";
          position: absolute;
          left: 8px; top: 0; bottom: 0; width: 14px;
          background-image: url(../assets/down-arrow.png);
          background-size: 10px auto;
          background-position: center;
          background-repeat: no-repeat;
          transition: all .3s ease;
        }
        &:hover{
          background-color: #f5f5fe;
        }
        &.active{
          background-color: #bdd8ff;
        }
      }
    }
    .btnAdd{
      margin: 16px;
    }
    .menuAction{
      position: absolute;
      right: 6px; top: 10px;
      display: flex;
      align-items: center;
      .actionItem{
        width: 30px; height: 30px;
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 50%;
        cursor: pointer;
        opacity: .65;
        position: relative;
        &.open{
          opacity: 1;
        }
        .info{
          position: absolute;
          font-size: 12px;
          background-color: #222;
          padding: 4px 6px;
          display: none;
          // width: 120px;
          // line-height: 1.1;
          font-weight: 400;
          white-space: nowrap;
          text-align: center;
          top: 100%; left: 50%;
          transform: translateX(-50%);
          color: #fff;
          z-index: 3;
          border-radius: 3px;
          b{
            font-weight: 600;
          }
          &:before{
            content: "";
            position: absolute;
            left: 50%; bottom: 100%;
            border-bottom: #222 4px solid;
            border-left: transparent 4px solid;
            border-right: transparent 4px solid;
            margin-left: -2px;
          }
        }
        &:hover{
          background-color: #fff;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          opacity: 1;
          .info{
            display: block;
          }
        }
        &.clicked{
          width: auto;
          padding-left: 23px;
          padding-right: 4px;
          border-radius: 0;
          display: flex;
          font-weight: 400;
          font-size: 14px;
          align-items: center;
          cursor: default;
          background-position: left center;
          box-shadow: none;
          background-color: transparent;
          background-image: url(../assets/clicked.png);
          background-size: 18px auto;
          margin-left: 4px;
        }
        &.more{
          background-image: url(../assets/more.png);
        }
        &.unpublished{
          background-image: url(../assets/eye-closed-o.png);
          background-size: 20px auto;
          // cursor: default;
          // background-color: transparent;
          // box-shadow: none;
        }
        &.published{
          background-image: url(../assets/eye-o.png);
          background-size: 20px auto;
        }
        .menuOverlay{
          position: fixed;
          left: 0; right: 0; top: 0; bottom: 0;
          cursor: default;
          z-index: 7;
        }
        .actionMenu{
          position: absolute;
          background-color: #fff;
          z-index: 10;
          padding: 8px 0;
          border-radius: 5px;
          box-shadow: 0 0 4px rgba(0, 0, 0, .2);
          right: 100%; top: 0;
          z-index: 7;
          .divider{
            height: 1px;
            background-color: #eee;
            margin: 5px 0;
          }
          li{
            margin: 0;
            border-radius: 0;
            list-style: none;
            font-size: 15px;
            white-space: nowrap;
            padding: 8px 24px;
            padding-left: 16px;
            cursor: pointer;
            color: #444;
            font-weight: 500;
            text-transform: none;
            transition: all .3s ease;
            display: flex;
            align-items: center;
            min-width: 120px;
            &.red{
              color: red;
            }
            .icon{
              width: 18px; height: 18px;
              margin-right: 10px;
              background-size: 16px auto;
              background-position: center;
              background-repeat: no-repeat;
              &.link{
                background-image: url(../assets/external-link-black.png);
                background-size: 16px auto;
                opacity: .65;
              }
              &.delete{
                background-image: url(../assets/delete.png);
              }
              &.lock{
                background-image: url(../assets/private-o.png);
                background-size: 18px auto;
              }
              &.unpublish{
                background-image: url(../assets/eye-closed-o.png);
                background-size: 19px auto;
              }
              &.publish{
                background-image: url(../assets/eye-o.png);
                background-size: 19px auto;
              }
              &.edit{
                background-image: url(../assets/edit-black.png);
                background-size: 15px auto;
                opacity: .76;
              }
              &.rename{
                background-image: url(../assets/rename.png);
              }
              &.main{
                background-image: url(../assets/crown-black.png);
                background-size: 15px auto;
                opacity: .64;
              }
            }
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
      }
    }
  }
  .menuCntMain .menuCnt .menuItem .menu{
    border-radius: 40px 0 0 40px;
    padding-left: 38px;
    &:before{
      left: 16px;
    }
  }
  .submenu{
    padding-left: 10px;
    padding-bottom: 6px;
    margin-bottom: 6px;
    position: relative;
    &:before{
      content: "";
      position: absolute;
      height: 1px;
      background-color: #eee;
      display: block;
      z-index: 3;
      bottom: 0; left: 50px; right: 0;
    }
    &.sortable-ghost{
      background-color: #eee !important;
      .menu{
        background-color: #fff !important;
      }
      *{
        opacity: 0;
      }
    }
    &.sortable-chosen{
      .menu{
        background-color: #fff !important;
      }
    }
    &.sortable-drag{
      background-color: #fff !important;
      .menu{
        background-color: #fff !important;
      }
    }
    .submenuTitle{
      padding: 10px 0 6px;
      padding-left: 38px;
      font-size: 14px;
      color: #999;
      cursor: pointer;
      // text-transform: uppercase;
      font-weight: 600;
      position: relative;
      cursor: pointer;
      span{
        padding-right: 24px;
        outline: 0;
        position: relative;
        white-space: nowrap;
        line-height: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        max-width: calc(100% - 24px);
        &:before{
          content: "";
          position: absolute;
          top: 0; right: 0; bottom: 0; width: 16px;
          background-image: url(../assets/rename.png);
          margin-top: -2px;
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: 0;
          transition: opacity .2s ease;
        }
        &:hover{
          &:before{
            opacity: .56;
          }
        }
      }
      .menuAction{
        top: 0;
        text-transform: none;
      }
      &:before{
        content: "";
        position: absolute;
        left: 18px; top: 11px;
        width: 12px; height: 12px;
        background-image: url(../assets/menu.png);
        background-size: 12px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .46;
      }
    }
  }
}
</style>

<style scoped lang="scss">
#menuManager{
  padding: 0;
  display: flex;
  flex-direction: column;
}
.currentBilling{
  margin: 0;
  padding: 0 30px;
  width: 100%;
  box-sizing: border-box;
  color: #555;
  display: flex;
  align-items: center;
  height: 140px;
  h4.cbTtl{
    margin: 0 0 2px;
    font-size: 34px;
    @media (max-width: 640px) {
      font-size: 24px;
    }
  }
  p.cbP{
    font-size: 16px;
    margin: 0 0 4px;
    @media (max-width: 640px) {
      font-size: 14px;
    }
    br{
      @media (max-width: 640px) {
        display: none;
      }
    }
  }
}
.menuSc{
  overflow-x: auto;
  padding: 0;
  height: calc(100% - 200px);
  box-sizing: border-box;
}
.menuCnt{
  min-height: 400px;
  margin: 0;
  display: flex;
  box-sizing: border-box;
  &.menuCntMain{
    border-top: #eee 1px solid;
    &.menuFixed{
      width: 100% !important;
    }
  }
  .menuDragableMain{
    display: flex;
    width: calc(100% - 180px);
    .menuItem{
      height: calc(100vh - 265px);
      overflow: auto;
      &.sortable-ghost{
        background-color: #eee !important;
        .menu{
          background-color: #fff !important;
        }
        *{
          opacity: 0;
        }
      }
      &.sortable-chosen{
        .menu{
          background-color: #fff !important;
        }
      }
      &.sortable-drag{
        background-color: #fff !important;
        .menu{
          background-color: #fff !important;
        }
      }
    }
  }
  .menuItem{
    width: 100%;
    border-right: #eee 1px solid;
    padding: 0 0 60px;
    box-sizing: border-box;
    &.last{
      border: none;
      width: 180px;
      &.noMenu{
        padding-left: 10px;
      }
    }
    .menu.addMenu{
      &:before{
        transform: none !important;
      }
    }
  }
  &.loading{
    height: calc(100vh - 250px);
    border-top: #eee 1px solid;
    background-image: url(../assets/loading-3.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px auto;
    position: relative;
    &:before{
      content: "";
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      background-image: url(../assets/cmsriver-logo.png);
      background-size: 30px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}

.started{
  .currentBilling{
    transition: all .3s ease;
    h4.cbTtl, p.cbP{
      transition: all .3s ease;
    }
    .actionCnt{
      transition: all .3s ease;
    }
  }
  .menuSc{
    transition: all .3s ease;
    .menuCnt .menuDragableMain .menuItem{
      transition: all .3s ease;
    }
  }
}

.collapsed{
  .currentBilling{
    height: 46px;
    h4.cbTtl, p.cbP{
      opacity: 0;
      visibility: hidden;
    }
    .actionCnt{
      margin-top: -89px;
      .actionItem.collapsed{
        transform: rotate(180deg);
      }
    }
  }
  .menuSc{
    top: 95px;
    .menuCnt .menuDragableMain .menuItem{
      height: calc(100vh - 96px);
    }
  }
}

.mmFooter{
  border-top: #eee 1px solid;
  padding: 0 24px;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0; bottom: 0; right: 0;
  height: 60px;
  background-color: #fff;
  @media (max-width: 1060px) {
    left: 0;
  }
  .draftStatus{
    color: red;
    background-color: #fff4f4;
    font-size: 15px;
    padding: 4px 10px;
    text-transform: uppercase;
    border-radius: 3px;
    border: red 1px solid;
  }
  .actionCnt{
    margin-left: auto;
    display: flex;
    align-items: center;
    .actionItem{
      width: 36px; height: 36px;
      border-radius: 50%;
      margin-left: 4px;
      transition: background-color .3s ease, opacity .3s ease;
      cursor: pointer;
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .46;
      position: relative;
      &.open{
        opacity: 1;
        .info{
          display: none !important;
        }
      }
      &.history{
        background-image: url(../assets/history.png);
      }
      &.draft{
        background-image: url(../assets/completed.png);
        background-size: 18px;
      }
      &.loading{
        background-image: url(../assets/loading-2.svg);
        background-size: 25px auto;
        opacity: .76;
      }
      .info{
        position: absolute;
        font-size: 12px;
        background-color: #222;
        padding: 4px 6px;
        display: none;
        bottom: 100%; left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        color: #fff;
        border-radius: 3px;
        &:before{
          content: "";
          position: absolute;
          left: 50%; top: 100%;
          border-top: #222 4px solid;
          border-left: transparent 4px solid;
          border-right: transparent 4px solid;
          margin-left: -2px;
        }
      }
      .actionMenu{
        background-color: #fff;
        position: absolute;
        bottom: 100%;
        padding: 8px 0;
        border-radius: 5px;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 0 0 4px rgba(0, 0, 0, .2);
        margin-bottom: 4px;
        cursor: default;
        z-index: 7;
        &:before{
          content: "";
          position: absolute;
          left: 50%; top: 100%;
          border-top: #eee 6px solid;
          border-left: transparent 6px solid;
          border-right: transparent 6px solid;
          margin-left: -4px;
        }
        &:after{
          content: "";
          position: absolute;
          left: 50%; top: 100%;
          border-top: #fff 4px solid;
          border-left: transparent 4px solid;
          border-right: transparent 4px solid;
          margin-left: -2px;
          z-index: 3;
        }
        h4{
          white-space: nowrap;
          padding: 10px 20px;
          margin: 0;
          font-weight: 600;
          font-size: 16px;
        }
        .historyCnt{
          width: 340px;
          min-height: 240px;
          max-height: 340px;
          overflow: auto;
          border-top: #eee 1px solid;
          border-bottom: #eee 1px solid;
          padding: 6px 0;
          box-sizing: border-box;
          &.noData{
            padding: 16px 20px;
            color: #767676;
            font-size: 14px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            .noDataIn{
              width: 100%;
            }
            img{
              display: block;
              width: 46px;
              margin: 0 auto 10px;
              opacity: .46;
            }
          }
          .historyItem{
            padding: 10px 20px;
            transition: all .3s ease;
            cursor: pointer;
            position: relative;
            padding-right: 76px;
            .historyStatus{
              position: absolute;
              right: 20px; top: 50%;
              transform: translateY(-50%);
              font-size: 14px;
              font-weight: 600;
              text-transform: uppercase;
              &.draft{
                color: red;
              }
              &.published{
                color: #0057d8;
              }
            }
            &:hover{
              background-color: #f5f5fe;
            }
            h5{
              margin: 0;
              font-size: 15px;
              font-weight: 600;
            }
            p{
              margin: 0;
              color: #767676;
              font-weight: normal;
              font-size: 14px;
              b{
                font-weight: 600;
                color: #444;
              }
            }
          }
          &.loading{
            background-image: url(../assets/loading-2.svg);
            background-size: 26px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
        .divider{
          height: 1px;
          background-color: #eee;
          margin: 5px 0;
        }
        li{
          list-style: none;
          font-size: 15px;
          white-space: nowrap;
          padding: 6px 24px;
          padding-left: 16px;
          cursor: pointer;
          transition: all .3s ease;
          display: flex;
          align-items: center;
          &.red{
            color: red;
          }
          .icon{
            width: 18px; height: 18px;
            margin-right: 10px;
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
            &.delete{
              background-image: url(../assets/delete.png);
            }
            &.save{
              background-image: url(../assets/save.png);
              background-size: 16px auto;
            }
          }
          &:hover{
            background-color: #f5f5fe;
          }
        }
      }
      &:hover{
        background-color: #eee;
        opacity: 1;
        .info{
          display: block;
        }
      }
    }
    .btn{
      margin-left: 26px;
      &.btnSecondary{
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
}
</style>
